@if (_context()?.yesNoText) {
  <div class="default-body-item">
    <h2>{{ _context().yesNoText | translate }}</h2>
  </div>
}

@if (isLoading$ | async; as isLoading) {
  <div
    [myreSpinLoader]="isLoading"
    [class.loading]="isLoading"
    class="default-body-item"
  ></div>
} @else {
  <div class="default-body-item">
    @if ((hasVisibleElement$ | async) && _context().formGroup) {
      <form [attr.myre-form-id]="_context().key">
        <myre-form
          [formGroup]="_context().formGroup"
          [elements]="_context().elements | async"
        />
      </form>
    }
  </div>
}
